// Fetch list

export const FETCH = 'reportVehicleKilometersTotal.FETCH'
export const FETCH_STARTED = 'reportVehicleKilometersTotal.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleKilometersTotal.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleKilometersTotal.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleKilometersTotal.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportVehicleKilometersTotal.CLEAR'

// Export

export const EXPORT = 'reportVehicleKilometersTotal.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleKilometersTotal.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleKilometersTotal.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleKilometersTotal.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleKilometersTotal.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleKilometersTotal.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleKilometersTotal.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleKilometersTotal.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportVehicleKilometersTotal.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleKilometersTotal.EXPORT_DETAILS_FULFILLED'
